import React from 'react';
import { CheckIcon } from 'lucide-react';
import { site, whyChooseUs } from '../data/site';
type WhyChooseUsProps = {
  serviceName?: string;
};
export function WhyChooseUs({
  serviceName
}: WhyChooseUsProps) {
  return <section className="bg-canvas py-20 lg:py-24" data-id="element-432" data-mp="q4r3rlsvaw4j">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16 lg:px-8" data-id="element-433" data-mp="u7e3s9zoznct">
        <div data-id="element-434" data-mp="g7mkpuubjgry">
          <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.95] text-ink sm:text-5xl" data-id="element-435" data-mp="g739ewz6bqmw">
            Why choose <span className="text-brand" data-id="element-436" data-mp="l7qxb9s3vrcw">Home Repair MD</span>
            {serviceName ? ` for ${serviceName.toLowerCase()}` : ''}
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-437" data-mp="79atbqlmoeyg">
            We’re a local, family-owned Las Vegas business. We treat customers the way we want to be treated — we show
            up as scheduled, clean up after ourselves and keep you updated from start to finish.
          </p>
          <p className="mt-4 font-semibold text-ink" data-id="element-438" data-mp="25k84d4adgrhk">{site.license}</p>
        </div>
        <ul className="grid content-start gap-x-8 sm:grid-cols-2" data-id="element-439" data-mp="1nctzjg06v9ab">
          {whyChooseUs.map(item => <li key={item} className="flex items-start gap-3 border-b border-line py-4 text-lg font-semibold text-ink" data-id="element-440" data-mp="1idhduyl2089b">
              <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-brand" strokeWidth={3} aria-hidden="true" data-id="element-441" data-mp="1s5n6maj4qtpk" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}